import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Check, X } from "lucide-react";

interface ServiceItem {
  name: string;
  included: boolean;
}

interface ServiceComparisonProps {
  title: string;
  services: ServiceItem[];
  description?: string;
}

export function ServicesComparison({ title, services, description }: ServiceComparisonProps) {
  return (
    <Card className="h-full">
      <CardHeader className="bg-green-50">
        <CardTitle className="text-xl sm:text-2xl text-green-800">
          {title}
        </CardTitle>
        {description && (
          <p className="text-green-700 mobile-text">{description}</p>
        )}
      </CardHeader>
      <CardContent className="p-0">
        <div className="overflow-hidden">
          {services.map((service, index) => (
            <div
              key={index}
              className={`flex items-center justify-between p-4 border-b last:border-b-0 ${
                index % 2 === 0 ? 'bg-gray-50' : 'bg-white'
              }`}
            >
              <span className="mobile-text font-medium text-gray-800 flex-1">
                {service.name}
              </span>
              <div className="ml-4 touch-target">
                {service.included ? (
                  <Check className="w-5 h-5 text-green-600" />
                ) : (
                  <X className="w-5 h-5 text-red-500" />
                )}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}